export default function logObject(component: string, page?: string) {
  return {
    component,
    page,
    product: 'commerce-webcomponents',
  };
}
